module.exports = __webpack_public_path__ + "img/portrait.ef7ca754.webp";